import { LoadingIndicator } from "../../../../../components";
import { InfiniteScrollGrid } from "../../../../../components/grid";
import { Schema } from "../../../../samples/@types/common";
import NetworkThreatCard from "../../../components/cards/NetworkThreatCard";
import NetworkThreatNoDataMsg from "../../../components/common/NetworkThreatNoDataMsg";

type Props<T> = {
  data: Array<T>;
  schema: Schema<T>;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasMore?: boolean;
  onNextPage: (pageId: string, pageSize: number) => void;
};

const IocTable = <T,>({
  data,
  schema,
  isLoading,
  isFetchingNextPage,
  hasMore,
  onNextPage
}: Props<T>) => (
  <InfiniteScrollGrid
    schema={schema}
    data={data}
    showLoading={isLoading}
    isFetchingNextPage={isFetchingNextPage}
    hasMore={Boolean(hasMore)}
    onLoadMore={onNextPage}
    maxHeight={545}
    headerCellClassName="bold"
    LoadingComponent={<LoadingIndicator style={{ margin: "10rem 0" }} />}
    emptyGridMsg={
      <NetworkThreatCard.Error className="m-y-20">
        <NetworkThreatNoDataMsg />
      </NetworkThreatCard.Error>
    }
  />
);

export default IocTable;
